import type { AdminTenant } from '@/types/control/tenant';

import { controlApiRequest } from './control-api-client';

/**
 * `GET /api/admin/tenants` returns a bare array, not an envelope.
 *
 * This list is the tenant picker for Field Mappings, AI Usage, Mesh Outbox and
 * Feature Flags, and the full listing for Tenants and Users. In Control three
 * of those shared a query key while two used raw `fetch` and refetched
 * independently; here every caller goes through one service and one query key.
 */
type TenantResponse = {
  id?: unknown;
  name?: unknown;
  status?: unknown;
};

function asString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export const adminTenantsService = {
  async list(signal?: AbortSignal): Promise<AdminTenant[]> {
    const res = await controlApiRequest<TenantResponse[] | null>({
      path: '/api/admin/tenants',
      signal,
    });

    // A bare array, and null when the backend has nothing to say.
    if (!Array.isArray(res)) {
      return [];
    }

    return res.map((tenant) => ({
      id: asString(tenant.id),
      name: asString(tenant.name),
      status: asString(tenant.status),
    }));
  },
};
